import getters from "./getters"
import actions from "./actions"
import mutations from "./mutations"
import cacheLs from "../cacheLs"

const state = {
  countryList: cacheLs.get_country_list()
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
